<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">ساعات الزيارة</h3>
            <p class="bullet03 depth">يرجى الالتزام بساعات الزيارة المحددة ساعات الزيارة محدودة للحفاظ على سلامة المريض وللوقاية من العدوى.</p>
            <p class="bullet03 depth">تقتصر الزيارة على ساعتين، ويكون الوصول إلى غرفة المريض من الساعة 18:00 حتى الساعة 20:00 في أيام الأسبوع ومن الساعة 10:00 إلى الساعة 12:00 ومن الساعة 18:00 إلى الساعة 20:00.</p>
            <p class="bullet03 depth">في عطلات نهاية الأسبوع والعطلات الرسمية. لا يُسمح بدخول الجناح بعد الساعة 8 مساءً نافذة الزيارة لوحدة العناية المركزة من الساعة 13:00 إلى الساعة 13:30 ومن الساعة 19:00 إلى الساعة 19:30</p>
            <p class="bullet03 depth">بإمكان الوصي الذي يحمل بطاقة الوصاية المقدمه من نقطة تسجيل الدخول الوصول إلى الغرفة في أي وقت.</p>
            <p class="bullet03 depth">إذا كان المريض خاضعًا للحجر الصحي بسبب مناعة ضعيفة أو مرض معد، فتقتصر الزيارة على منع انتقال العدوى وحماية المريض.</p>
            <p class="bullet03 depth">إذا كنت لا تريد أي زائر لأسباب تتعلق بالخصوصية، فالرجاء إخبار فريق الإدارة أو مكتب الممرضة عندما يتم إدخالك إلى المستشفى.</p>
            <p class="bullet03 depth">يُرجى الاحتفاظ بسجل الزيارة للتمكن من إدارة عملية الزيارة</p>
        </div>
        <div class="info">
            <h3 class="bullet01">موانع الزيارة</h3>
            <p class="bullet03 depth">من أجل الشفاء العاجل للمرضى واستقرارهم والوقاية من العدوى يُحظر على الأطفال الذين تقل أعمارهم عن 13 عامًا زيارة جناح العدوى ووحدة العناية المركزة.</p>
            <p class="bullet03 depth">يمكن منع زيارات ولي الأمر إذا كان مصابًا بالبرد أو غيره من الأمراض المعدية</p>
            <p class="bullet03 depth">لا يمكن حمل أي مصدر محتمل للعدوى مثل النباتات أو أواني الزهور أو الحيوانات داخل المبنى.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>